import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["modal", "modalImage"]

  show(e) {
    const imgUrl = e.currentTarget.dataset.lightboxUrl
    if (!imgUrl) return

    this.modalImageTarget.src = imgUrl
    this.modalTarget.classList.remove('tw:hidden')
  }

  hide() {
    this.modalImageTarget.src = ""
    this.modalTarget.classList.add('tw:hidden')
  }
}
